import ContentLoader from 'react-content-loader';
import classNames from 'classnames';

export function SkeletonCard({
  height = 20,
  ...props
}: {
  className?: string;
  height?: number;
}) {
  return (
    <ContentLoader
      className={classNames('rounded-md', props.className)}
      foregroundColor="#FFF"
      viewBox={`0 0 355 ${height}`}
    >
      <rect x="0" y="0" rx={3} width="600" height={height} />
    </ContentLoader>
  );
}

export function ThickSkeletonCard() {
  return (
    <ContentLoader foregroundColor="#FFF" viewBox="0 0 100 40">
      <rect x="0" y="0" rx={1.5} width="100" height="40" />
    </ContentLoader>
  );
}

export function CardLoader({ count = 4 }: { count?: number }) {
  return (
    <div className={'w-full'}>
      {new Array(count).fill(null).map((_, i) => (
        <SkeletonCard key={i} height={24} className={'my-3'} />
      ))}
    </div>
  );
}
